import './brokerIAPagination.scss';

// @vendors
import React from 'react';

// @utilities
import { recordLinkV2 } from 'utilities/tagging';
import { PropTypes } from 'prop-types';
import PaginationButtons from '../../../../commons/paginationButtons/paginationButtons';

const BrokerIAPagination = ({ currentPage = 0, onPagePress, totalPages }) => {
    const loadPage = pageNumber => {
        if (onPagePress) {
            onPagePress(pageNumber);
        }
    };

    const getEventType = (selected, diff) => {
        if (selected === 1) return 'start';

        if (selected === totalPages) return 'last';

        if (diff === -1) return 'previous';

        if (diff === 1) return 'next';

        return `<${selected}>`;
    };

    const onClickButton = page => {
        const selectedPage = page - 1;

        loadPage(selectedPage);

        recordLinkV2({
            accionEvento: 'paginator',
            categoriaEvento: 'IAInvestmentHomeInteractions',
            etiquetaEvento: getEventType(page, selectedPage - currentPage),
        });
    };

    return (
        <div className="brokerIA-pagination">
            <PaginationButtons
                totalPages={totalPages}
                callbackFunction={onClickButton}
                pageNumber={currentPage + 1}
            />
        </div>
    );
};

BrokerIAPagination.propTypes = {
    currentPage: PropTypes.number.isRequired,
    onPagePress: PropTypes.function,
    totalPages: PropTypes.number.isRequired,
};

export default BrokerIAPagination;
